<style>
  .info {
    position: relative;
    cursor: pointer;
  }

  .info::after {
    content: "Have a price in mind?\A Submit your Preferred Price and the retailer will review your offer.\A Please note that acceptance is not guaranteed.";
    position: absolute;
    width: auto;
    min-width: 150px;
    max-width: 300px;
    top: -120%;
    left: -200%;
    transform: translateX(-50%);
    background-color: rgba(0, 0, 0, 0.7);
    color: white;
    padding: 6px 12px;
    border-radius: 4px;
    visibility: hidden;
    opacity: 0;
    transition: opacity 0.3s ease, visibility 0s linear 0.3s;
    white-space: pre-line;
    z-index: 10;
    word-wrap: break-word;
  }

  .info:hover::after {
    visibility: visible;
    opacity: 1;
    transition: opacity 0.2s ease, visibility 0s linear 0s;
  }
</style>

<div class="container fw-b">
  <app-linker-route
    [headingName]="headingName"
    [linkerRouteItems]="linkerRouteItems"
  ></app-linker-route>
</div>
<div class="container mt-4 mb-5">
  <div class="">
    <div class="row mt-3 mb-5 product-detail-box">
      <div class="product-view">
        <div class="row categoryimageView">
          <span>
            <img
              class="image-custom qwqwqw"
              [hidden]="!imageLoaded"
              (load)="onImageLoad()"
              [src]="imgurl"
              alt=""
            />
            <ngx-skeleton-loader
              *ngIf="!imageLoaded"
              [theme]="{
                width: '510px',
                height: '405px',
                position: 'relative'
              }"
              count="1"
            ></ngx-skeleton-loader>
            <span
              class="heart"
              *ngIf="isLoggedIn"
              (click)="addWishlist(productDetails?._id)"
            >
              <i
                class="fa fa-heart-o"
                *ngIf="productDetails?.isLike == false"
              ></i>
              <i
                class="fa fa-heart"
                style="color: red"
                *ngIf="productDetails?.isLike == true"
              ></i>
            </span>
            <span
              class="heart"
              *ngIf="!isLoggedIn"
              (click)="showMessage()"
              [routerLink]="['/login']"
            >
              <i
                class="fa fa-heart-o"
                *ngIf="productDetails?.isLike == false"
              ></i>
              <i
                class="fa fa-heart"
                style="color: red"
                *ngIf="productDetails?.isLike == true"
              ></i>
            </span>
          </span>
        </div>
        <div
          class="d-flex mt-4"
          style="overflow: scroll"
          [ngClass]="
            productDetails?.productImage > 2 ? 'justify-content-between' : ''
          "
          *ngIf="productDetails?.productImage?.length > 1"
        >
          <div
            *ngFor="let item of productDetails?.productImage; let i = index"
            class=""
          >
            <img
              class="custom-img h-100 change-img"
              style="cursor: pointer"
              [src]="item"
              (click)="changeProductimage(item)"
            />
          </div>
        </div>
      </div>
      <div class="product-detail digitalartBox">
        <!-- <div class="row"> -->
        <div class="">
          <div style="display: flex; align-items: flex-start; gap: 16px">
            <div class="digitalartconBox">
              <p class="prdct-home">{{ productDetails?.productName }}</p>
            </div>
            <div
              class="digitalartconBox interest"
              style="
                margin-left: auto;
                padding: 0px;
                border: 2px solid #c8102e;
                display: flex;
                align-items: center;
                justify-content: center;
                padding: 3px 5px;
                gap: 5px;
                max-width: 150px;
              "
            >
              <button
                class="btn btn-theme int"
                (click)="openModal()"
                style="
                  padding: 0;
                  padding-bottom: 2px;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  color: #c8102e;
                "
              >
                Preferred Price
              </button>
              <span
                class="info"
                style="width: 16px; height: 16px; cursor: pointer"
              >
                <img
                  src="./../../../../assets/svg/info.svg"
                  style="width: 100%; height: 100%"
                  alt=""
                />
              </span>
            </div>
          </div>
          <!-- <div class="col-8 digitalartconBox">
            <p class="prdct-home">{{ productDetails?.productName }}</p>
          </div>
          <div class="col-4 digitalartconBox interest " style="padding: 0px; border: 2px solid #c8102e;">
            <button class="btn btn-theme int" (click)="openModal()" style="padding: 0px;">Preferred Price</button>
          </div> -->
          <div class="col-12 digitalartconBox">
            <p class="para-text-common mb-0 digitalartconBox">
              Product ID : {{ id(productDetails?._id) }}
            </p>
          </div>
          <div class="col-6 digitalartconBox">
            <ng-container *ngIf="!productDetails?.isCampaignActive">
              <div
                class="row justify-content-between"
                style="margin-right: 18px"
              >
                <span [ngClass]="{ crossPrice: productDetails?.isDealActive }">
                  {{
                    mrp
                      ? getPrice(mrp | currency : "ZAR" : "R")
                      : productDetails?.priceSizeDetails[0]?.price &&
                        getPrice(
                          productDetails?.priceSizeDetails[0]?.price
                            | currency : "ZAR" : "R"
                        )
                  }}
                </span>
                <span
                  *ngIf="productDetails?.isDealActive"
                  class="priceTestPColor"
                >
                  {{
                    afterDiscountPrice
                      ? getPrice(afterDiscountPrice | currency : "ZAR" : "R")
                      : getPrice(afterDiscountPrice | currency : "ZAR" : "R")
                  }}
                </span>
                <span
                  *ngIf="productDetails?.isDealActive"
                  class="priceTestPColorD"
                >
                  {{ productDetails?.dealDiscount }}% off
                </span>
              </div>
            </ng-container>
            <ng-container *ngIf="productDetails?.isCampaignActive">
              <ng-container *ngIf="iscampainValid[index]">
                <div
                  class="row justify-content-between"
                  style="margin-right: 18px"
                >
                  <span class="crossPrice">
                    {{
                      mrp
                        ? getPrice(mrp | currency : "ZAR" : "R")
                        : productDetails?.priceSizeDetails[0]?.price &&
                          getPrice(
                            productDetails?.priceSizeDetails[0]?.price
                              | currency : "ZAR" : "R"
                          )
                    }}
                  </span>
                  <span class="priceTestPColor">
                    {{
                      getcampaignDiscountedPrice()?.discountedPrice
                        ? getPrice(
                            getcampaignDiscountedPrice().discountedPrice
                              | currency : "ZAR" : "R"
                          )
                        : getPrice(
                            getcampaignDiscountedPrice().discountedPrice
                              | currency : "ZAR" : "R"
                          )
                    }}
                  </span>
                  <span class="priceTestPColorD">
                    {{ getcampaignDiscountedPrice()?.discountedPercentage }}%
                    off
                  </span>
                </div>
                <div class="col-12 post d-flex">
                  <label
                    style="
                      white-space: pre;
                      margin: 4px;
                      font-weight: bold;
                      color: #444;
                    "
                    >Campaign Ends In:
                  </label>
                  <div class="timer-container">
                    <span class="countdown-timer">{{
                      getCountDownTime(productDetails?.campainId?.endDate) ||
                        "00D:00H:00M:00S"
                    }}</span>
                  </div>
                </div>
              </ng-container>

              <div
                *ngIf="!iscampainValid[index]"
                class="row justify-content-between"
                style="margin-right: 18px"
              >
                <span>
                  {{
                    mrp
                      ? getPrice(mrp | currency : "ZAR" : "R")
                      : productDetails?.priceSizeDetails[0]?.price &&
                        getPrice(
                          productDetails?.priceSizeDetails[0]?.price
                            | currency : "ZAR" : "R"
                        )
                  }}
                </span>
              </div>
            </ng-container>
          </div>
          <div class="bordernone col-12 mt-2 mb-2">
            <img
              src="assets/latest/veriticalline.svg"
              style="height: 2px; width: 100%"
              alt=""
            />
          </div>
        </div>
        <ng-container *ngIf="!isLoading">
          <app-table-loader></app-table-loader>
        </ng-container>
        <ng-container *ngIf="isLoading">
          <div class="" style="margin-top: 1em">
            <div class="row">
              <div class="col-4 pr-0 digitalartconBox">
                <p class="pid">Product Name</p>
              </div>
              <div class="">:</div>
              <div class="col-7">
                <p class="pid-1">{{ productDetails?.productName }}</p>
              </div>
            </div>
            <div class="row">
              <div class="col-4 pr-0 digitalartconBox">
                <p class="pid">Category Name</p>
              </div>
              <div class="">:</div>
              <div class="col-7">
                <p class="pid-1">
                  {{ productDetails?.categoryId.categoryName }}
                </p>
              </div>
            </div>
            <!-- <div class="row">
              <div class="col-4 pr-0 digitalartconBox">
                <p class="pid">Quantity Available</p>
              </div>
              <div class="">:</div>
              <div class="col-7">
                <p class="pid-1">
                  {{
                  isOutofStock(
                  quantity,
                  productDetails?.priceSizeDetails[0]?.quantity
                  )
                  }}
                </p>
              </div>
            </div> -->

            <div class="row">
              <div class="col-4 pr-0 digitalartconBox">
                <p class="pid">Size/Value</p>
              </div>
              <div class="">:</div>
              <div class="col-7 flex-data">
                <ng-container
                  *ngFor="
                    let item of productDetails?.priceSizeDetails;
                    let i = index
                  "
                >
                  <p
                    class="pid-1 new-loop-para"
                    (click)="
                      price(
                        item?.weight,
                        item.volume,
                        item?.price,
                        item?.quantity,
                        item?.value,
                        item?.id,
                        item?.unit,
                        i
                      )
                    "
                    [ngClass]="{ active: value == item?.value }"
                  >
                    {{ item?.value }}
                    {{ item?.unit !== "other" ? "" + item?.unit : "" }}
                  </p>
                </ng-container>
              </div>
            </div>
          </div>

          <div class="mt-4 pt-3 descriptionBox">
            <span class="d-flex justify-content-between">
              <h1 class="text-center desc">Description</h1>
            </span>
            <p
              style="word-break: break-word"
              class="text-left descrip ml-3"
              [innerHTML]="rawText(productDetails?.description)"
            >
              <!-- {{  }} -->
            </p>
          </div>

          <div class="ml-3 mt-3 addtocartBox">
            <button
              class="add-cart"
              *ngIf="isLoggedIn && quantity == 0"
              disabled
            >
              Out of stock
            </button>
            <button
              class="add-cart"
              *ngIf="isLoggedIn && quantity > 0 && flag"
              (click)="addToCart()"
            >
              Add to Cart
            </button>
            <button
              class="add-cart"
              *ngIf="isLoggedIn && quantity > 0 && !flag"
              style="opacity: 0.75; color: white;"
            >
              Loading..
            </button>
            <button
              class="add-cart"
              *ngIf="!isLoggedIn"
              (click)="showMessage()"
              [routerLink]="['/login']"
            >
              Add to Cart
            </button>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>
<!-- service slider -->
<div
  class="container mt-5 pt-5 likeBox"
  *ngIf="iaAPILoaded && serviceData?.length"
>
  <!-- <hr class="mt-3"> -->
  <div class="d-flex justify-content-start">
    <h1
      class="heading-text-cat"
      style="color: #000000 !important; font-size: 22px !important"
    >
      YOU MAY ALSO LIKE
    </h1>
  </div>
  <div class="items mt-4">
    <div class="slick_slider">
      <div class="service_slider slider d-flex slider-customize">
        <ng-container *ngIf="serviceData?.length">
          <ng-container *ngFor="let data of serviceData; let i = index">
            <div *ngIf="productDetails._id !== data._id">
              <product-card
                [data]="data"
                (on_Click)="viewProducts(data?._id)"
              ></product-card>
            </div>
          </ng-container>
        </ng-container>

        <ng-container *ngIf="!serviceData?.length">
          <div>
            <ng-container *ngFor="let data of length(5)">
              <product-card
                [data]="data"
                width="228px"
                height="300px"
              ></product-card>
            </ng-container>
          </div>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<div class="container mt-5 pt-5 likeBox" *ngIf="!iaAPILoaded">
  <!-- <hr class="mt-3"> -->
  <div class="d-flex justify-content-start">
    <h1
      class="heading-text-cat"
      style="color: #000000 !important; font-size: 22px !important"
    >
      YOU MAY ALSO LIKE
    </h1>
  </div>
  <div class="items mt-4">
    <div class="d-flex flex-wrap justify-content-between">
      <ng-container *ngFor="let data of length(5)">
        <product-card [data]="data" width="228px" height="300px"></product-card>
      </ng-container>
    </div>
  </div>
</div>
<div
  class="modal fade"
  id="interestedPriceModal"
  tabindex="-1"
  role="dialog"
  aria-labelledby="exampleModalLabel"
  aria-hidden="true"
>
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      <div class="modal-header" style="height: 90px; background: #bf1e2e">
        <h5
          class="modal-title"
          id="exampleModalLabel"
          style="width: 135px; height: 60px"
        >
          <img
            style="height: 100%; width: 100%; object-fit: cover"
            src="assets/img/whiteLogo.png"
            alt=""
          />
        </h5>
        <button
          type="button"
          class="close"
          data-dismiss="modal"
          aria-label="Close"
        >
          <!-- <span aria-hidden="true" style="color: white;">&times;</span> -->
        </button>
      </div>
      <div class="modal-body">
        <div class="form" *ngIf="showInterestedPriceModal">
          <div class="row justify-content-between">
            <div class="col-md-12 text-center">
              <img
                class="custom-img h-100 change-img"
                style="cursor: pointer; height: 200px !important"
                [src]="productDetails?.productImage[0]"
              />
            </div>

            <div class="col-md-12 text-left" style="padding: 0px">
              <div class="form-group d-flex">
                <label for="size" style="margin-top: 10px; min-width: 126px"
                  >Size/Value :-
                </label>
                <ng-container
                  *ngFor="let item of productDetails?.priceSizeDetails"
                >
                  <p
                    class="pid-1 new-loop-para"
                    (click)="
                      price(
                        item?.price,
                        item?.quantity,
                        item?.value,
                        item?.id,
                        item?.unit
                      )
                    "
                    [ngClass]="{ active: value == item?.value }"
                  >
                    {{ item?.value }}
                    {{ item?.unit !== "other" ? "" + item?.unit : "" }}
                  </p>
                </ng-container>
              </div>
            </div>

            <div class="col-md-12 text-left" style="padding: 0px">
              <div class="form-group d-flex">
                <div style="min-width: 110px">Price :-</div>
                <div class="col-6 digitalartconBox">
                  <div class="row">
                    <span>
                      {{
                        mrp
                          ? getPrice(mrp | currency : "ZAR" : "R")
                          : productDetails?.priceSizeDetails[0]?.price &&
                            getPrice(
                              productDetails?.priceSizeDetails[0]?.price
                                | currency : "ZAR" : "R"
                            )
                      }}
                    </span>
                  </div>
                </div>
              </div>
            </div>
            <div class="col-md-12 text-left" style="padding: 0px">
              <!-- <div class="form-group">
                <label for="exampleInputEmail1">Interested Price</label>
                <input type="text" class="form-control"  aria-describedby="toDate"
                  placeholder="Enter Interested Price"
                
                  (keypress)="commonService.numberOnly($event)"
                  (keypress)="commonService.preventSpace($event);commonService.numberOnly($event)" 
                  onkeyup="if(this.value > 99) this.value = 99; if(this.value < 0) this.value = 0;"
                  >
              </div> -->
              <div class="form-group d-flex">
                <div>
                  <label
                    for="exampleInputEmail1"
                    style="margin-top: 10px; min-width: 110px"
                    >Interested Price:-</label
                  >
                </div>
                <div class="col-md-6">
                  <input
                    type="text"
                    [(ngModel)]="interestedPrice"
                    aria-describedby="toDate"
                    placeholder="Enter Interested Price"
                    (keypress)="commonService.numberOnly($event)"
                    (keypress)="
                      commonService.preventSpace($event);
                      commonService.numberOnly($event)
                    "
                    style="background: #fff !important"
                  />
                  <div
                    *ngIf="mrp < interestedPrice || interestedPrice <= 0"
                    style="color: #bf1e2e"
                  >
                    Invalid Price
                  </div>
                </div>
                <!-- <div class="error" *ngIf="mrp">
                  <p >Can not add more amount than actual amount</p>
                </div> -->
              </div>
              <div class="form-group d-flex">
                <div>
                  <label
                    for="exampleInputEmail1"
                    style="margin-top: 10px; min-width: 110px"
                    >Quantity:-</label
                  >
                </div>
                <div class="col-md-6">
                  <input
                    class="form-control"
                    type="number"
                    [(ngModel)]="intrestedQuantity"
                    (keypress)="commonService.numberOnly($event)"
                    (keypress)="
                      commonService.preventSpace($event);
                      commonService.numberOnly($event)
                    "
                  />
                  <div
                    *ngIf="quantity < intrestedQuantity"
                    style="color: #bf1e2e"
                  >
                    Quantity should be equal or less than Available Quantity
                  </div>
                  <div *ngIf="intrestedQuantity <= 0" style="color: #bf1e2e">
                    Quantity must be greater than 0
                  </div>
                </div>

                <!-- <div class="col-md-6">
                  <input
                    class="form-control"
                    type="number"
                    [(ngModel)]="intrestedQuantity"
                    (keypress)="commonService.preventSpace($event); commonService.numberOnly($event)"
                    (ngModelChange)="validateQuantity()"
                    min="0"
                  />
                  <div *ngIf="showValidationError" style="color: #BF1E2E;">
                    Quantity should be equal or less than Available Quantity
                  </div>
                </div> -->

                <!-- <div class="error" *ngIf="mrp">
                  <p >{{quantity}}</p>
                </div> -->
              </div>
            </div>

            <div class="form-group d-flex">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  gap: 5px;
                "
              >
                <input
                  type="radio"
                  (change)="spordicType = 'AUTOMATIC'"
                  name="spordaicSelection"
                  id="auto-spordaic"
                  [checked]="spordicType === 'AUTOMATIC'"
                />
                <label for="auto-spordaic" style="margin-top: 0px"
                  >Automatic : Buy automatically when the campaign
                  starts.</label
                >
              </div>
            </div>
            <div class="form-group d-flex">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  gap: 5px;
                "
              >
                <input
                  type="radio"
                  (change)="spordicType = 'SEMIAUTOMATIC'"
                  name="spordaicSelection"
                  id="semi-spordaic"
                  [checked]="spordicType === 'SEMIAUTOMATIC'"
                />
                <label for="semi-spordaic" style="margin-top: 0px"
                  >Semi Automatic : Let me review the cart before
                  purchase.</label
                >
              </div>
            </div>
            <div class="form-group d-flex">
              <div
                style="
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  gap: 5px;
                "
              >
                <input
                  type="radio"
                  (change)="spordicType = 'MANUAL'"
                  name="spordaicSelection"
                  id="manual"
                  [checked]="spordicType === 'MANUAL'"
                />
                <label for="manual" style="margin-top: 0px">
                  Manual: Receive notification when campaign is started.</label
                >
              </div>
            </div>
          </div>
          <!-- <div class="col-md-12 text-center">
              <div class="form-group">
                <label for="exampleInputEmail1">Available Stock {{ campaignModel[selectedIndex].quantity - campaignModel[selectedIndex].releaseQuantity}}</label>
              </div>
            </div> -->

          <div class="col-md-12 text-center mt-3">
            <button
              class="btn btn-theme"
              (click)="confirmInterestedPrice()"
              style="font-weight: 600"
              [disabled]="
                mrp < interestedPrice ||
                quantity < intrestedQuantity ||
                (interestedPrice && intrestedQuantity) == 0 ||
                (interestedPrice && intrestedQuantity) == null ||
                interestedPrice <= 0
              "
            >
              Confirm Price
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
